import { loadable } from 'utils';

export const CreateChannelHome = loadable(() => import('./CreateChannelHome'), {});
export const MainChannelHome = loadable(() => import('./MainChannelHome'), {});
export const RedirectHome = loadable(() => import('./RedirectHome'), {});
export const SelectChannelHome = loadable(() => import('./SelectChannelHome'), {});
export const StaticHome = loadable(() => import('./StaticHome'), {});
